enum EImagingRequestor {
  RockMaker = 10,
  RockImager = 20,
  CrystalFarm = 30,
  AutoInspeX = 40,
  Rhombix = 50,
  RoboMicroscope = 60,
  TriTek = 70,
  DSI = 80,
}

enum EImagingSourceType {
  Scheduling = 1,
  Manual = 2,
  ImageNow = 3,
  Temporary = 4,
}

enum EImagingTaskSource {
  // RockMaker
  RMScheduling = EImagingRequestor.RockMaker + EImagingSourceType.Scheduling,
  RMManual = EImagingRequestor.RockMaker + EImagingSourceType.Manual,
  RMImageNow = EImagingRequestor.RockMaker + EImagingSourceType.ImageNow,
  RMTemporary = EImagingRequestor.RockMaker + EImagingSourceType.Temporary, // Temporary task created when temporary inspection is generated
  // RockImager
  RIManual = EImagingRequestor.RockImager + EImagingSourceType.Manual,
  RIImageNow = EImagingRequestor.RockImager + EImagingSourceType.ImageNow,
  // CrystalFarm
  CrystalFarmManual = EImagingRequestor.CrystalFarm + EImagingSourceType.Manual,
  // AutoInspeX
  AutoInspeXManual = EImagingRequestor.AutoInspeX + EImagingSourceType.Manual,
  // Rhombix
  RhombixManual = EImagingRequestor.Rhombix + EImagingSourceType.Manual,
  // RoboMicroscope
  RoboMicroscopeManual = EImagingRequestor.RoboMicroscope + EImagingSourceType.Manual,
  // TriTek
  TriTekManual = EImagingRequestor.TriTek + EImagingSourceType.Manual,
  // DSI
  DSIManual = EImagingRequestor.DSI + EImagingSourceType.Manual,
}

export default EImagingTaskSource;
